import React, { Fragment, useEffect, useState } from "react";
import { Col, Card, Dropdown } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import LinearProgress from "@mui/material/LinearProgress";
import * as constants from "../../../utils/Constants";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { toast, ToastContainer } from "react-toastify";
import {
  TextField,
  Grid,
  useMediaQuery,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import ConfirmationModal from "../modal/ConfirmationModal";

const CompanyMaster = () => {
  const { state } = useLocation();
  const location = useLocation();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [page, setPage] = useState(
    Number(location?.pageCallBack) > 1 ? Number(location?.pageCallBack) : 1
  );
  const [sortBy, setSortBy] = useState(location?.sortByCallBack);
  const [order, setOrder] = useState(location?.orderCallBack);
  const [pageDetails, setPageDetails] = useState({});
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [isCompnayUpdate, setIsCompnayUpdate] = useState(false);
  const [companyDetails, setCompanyDetails] = useState({});
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [isStatusModal, setIsStatusModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedManager, setSelectedManager] = useState(null);
  const [keyAccountManager, setKeyAccountManager] = useState([]);
  const [searchText, setSearchText] = useState(location?.searchCallBack);
  const [userData, setUserData] = useState([]);
  //   let userData = [];
  let loggedInUser = JSON.parse(localStorage.getItem("user"));
  let userRole = loggedInUser?.roles;

  useEffect(() => {
    window.scrollTo(0, 0);
    getListUser(page - 1, searchText, sortBy, order);
    handleGetKeyAccountManager();
    fetchCountries();
  }, []);

  //popup filter
  const openFilter2 = () => {
    document.getElementById("staticBackdrop").style.display = "none";
  };
  const clearFilter = () => {
    window.location.reload();
  };
  const openFilter = () => {
    document.getElementById("staticBackdrop").style.top =
      document.getElementById("popupbox").getBoundingClientRect().y + 20 + "px";
    document.getElementById("staticBackdrop").style.left =
      document.getElementById("popupbox").getBoundingClientRect().x -
      310 +
      "px";
    document.getElementById("staticBackdrop").style.display = "block";
    if (openFilterClicked) {
      openFilter2();
      openFilterClicked = false;
    } else {
      openFilterClicked = true;
    }
  };
  var openFilterClicked = false;

  //  Filter Dropdown
  const [loginData, setLoginData] = useState({
    ...state,
    ...location?.filterDataCallback,
  });

  const statusOptions = () => {
    return [
      { label: "Active", value: "0" },
      { label: "Inactive", value: "1" },
    ];
  };

  const handleStatus = (value) => {
    setFilterStatus(value?.map((item) => item.value));
    // setSelectedStatus(value);
    // const newLoginData = { ...loginData };
    // let statusChange = "";
    // if (value) {
    //   statusChange = value[0]?.value?.toString();
    //   newLoginData["activeFlag"] = statusChange;
    // } else {
    //   statusChange.length = 0;
    //   newLoginData["activeFlag"] = statusChange;
    // }
    // setLoginData(newLoginData);
  };

  //Filter
  const handleFilter = (value) => {
    document.getElementById("staticBackdrop").style.display = "none";
    if (location?.pageCallBack) {
      getListUser(page - 1, searchText, sortBy, order, filterStatus);
    } else {
      // setPage(1)
      getListUser(0, searchText, sortBy, order, filterStatus);
    }
  };

  function getListUser(page, search, sort, order, filter) {
    fetch(
      `${constants.ListCompanyMasterUrl}?page=${page}&search=${
        search || ""
      }&sortBy=${sort || ""}&sort=${order || ""}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        // body: JSON.stringify({ activeFlag: filter } || {}),
        body: JSON.stringify(filter ? { activeFlag: filter } : {}),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setUserData(result?.data?.content);
          //   setItems(result?.data?.content);
          setPageDetails(result.data);
        },
        (error) => {
          console.error("Error", error);
        }
      );
  }

  const handlePageChange = (event, value) => {
    setPage(value);
    getListUser(value - 1, searchText, sortBy, order);
  };

  const handleSortOntable = (key, order) => {
    setSortBy(key);
    setOrder(order);
    if (location?.pageCallBack) {
      getListUser(page - 1, searchText, key, order);
    } else {
      // setPage(1)
      getListUser(0, searchText, key, order);
    }
  };

  const handleEdit = (user) => {
    // history.push({
    //   pathname: "/create-user",
    //   state: selectedRow,
    // });
    setIsCompnayUpdate(true);
    setFormData({
      companyName: user.companyName,
      gstNumber: user.gstNumber,
      country: user.country,
      state: user.state,
      city: user.city,
      address: user.address,
      pincode: user.pincode,
      spokeName: user.spokeName,
      spokeContactNumber: user.spokeContactNumber,
      spokeEmail: user.spokeEmail,
      communicationName: user.communicationName,
      communicationMobileNumber: user.communicationMobileNumber,
      communicationEmail: user.communicationEmail,
    });
    setAddModalOpen(true);
  };

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText]);

  const handleSearch = (search) => {
    if (location?.pageCallBack) {
      getListUser(page - 1, search || searchText, sortBy, order, filterStatus);
    } else {
      setPage(1);
      getListUser(0, search || searchText, sortBy, order, filterStatus);
    }
  };

  const [test, settest] = useState(0);

  // use effect
  useEffect(() => {
    chackboxFun();
  }, [test]);

  const chackbox = document.querySelectorAll(".application_sorting_1 input");
  const motherChackBox = document.querySelector("#checkAll");

  const chackboxFun = (type) => {
    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };

  const handleGetKeyAccountManager = () => {
    fetch(constants.KeyAccountManagerGetUrl, {
      headers: {
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.json())
      .then((result) => {
        setKeyAccountManager(result.data);
      });
  };

  const handleManagerSelect = (manager) => {
    setSelectedManager(manager);
  };

  const handleAssignChange = () => {
    // const selectedManager = keyAccountManager.find(
    //   (manager) => manager.id === selectedManager
    // );

    fetch(`${constants.AssignCompanyURL}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify({
        companyId: selectedUser.companyId,
        keyAccountManagerId: selectedManager.id,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.message) {
          if (res.message.messageCode) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setShowAssignModal(false);

            const updatedUserData = userData?.map((user) =>
              user.companyId === selectedUser?.companyId
                ? { ...user, keyAccountManagerName: selectedManager.name }
                : user
            );
            setUserData(updatedUserData);
          }
        } else if (res.error) {
          if (res.error.errorCode) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
          }
        }
      });
  };

  const [formData, setFormData] = useState({
    companyName: "",
    gstNumber: "",
    country: "",
    state: "",
    city: "",
    address: "",
    pincode: "",
    spokeName: "",
    spokeContactNumber: "",
    spokeEmail: "",
    communicationName: "",
    communicationMobileNumber: "",
    communicationEmail: "",
  });
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [companyStatusData, setCompanyStatusData] = useState({
    id: "",
    companyName: "",
    companyStatus: "",
  });

  const [filterStatus, setFilterStatus] = useState("");
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const fetchCountries = async () => {
    try {
      fetch(constants.GetCountriesUrl, {
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          setCountries(result.data);
        });
    } catch (error) {
      console.error("Failed to fetch countries", error);
    }
  };

  const fetchStates = async (countryCode) => {
    try {
      fetch(`${constants.GetStatesUrl}/${countryCode}`, {
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          setStates(result.data);
          setCities([]);
        });
    } catch (error) {
      console.error("Failed to fetch states", error);
    }
  };

  const fetchCities = async (stateCode) => {
    try {
      fetch(`${constants.GetCityByStateNameUrl}/${stateCode}`, {
        headers: {
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
      })
        .then((res) => res.json())
        .then((result) => {
          setCities(result.data);
        });
    } catch (error) {
      console.error("Failed to fetch cities", error);
    }
  };

  const handleSubmit = () => {
    setIsApiLoading(true);
    fetch(
      `${
        isCompnayUpdate ? constants.UpdateCompanyUrl : constants.AddCompanyUrl
      }`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        body: JSON.stringify(
          isCompnayUpdate
            ? { ...formData, companyId: companyStatusData.id }
            : formData || {}
        ),
        // body: formData
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.message) {
          if (res.message.messageCode) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setAddModalOpen(false);
            setFormData({
              companyName: "",
              gstNumber: "",
              country: "",
              state: "",
              city: "",
              address: "",
              pincode: "",
              spokeName: "",
              spokeContactNumber: "",
              spokeEmail: "",
              communicationName: "",
              communicationMobileNumber: "",
              communicationEmail: "",
            });
            // handlePageChange();
            getListUser(page - 1, searchText, sortBy, order);
            setIsApiLoading(false);
          }
        } else if (res.error) {
          if (res.error.errorCode) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setIsApiLoading(false);
          }
        }
      });
  };

  const handleStatusChange = () => {
    setIsApiLoading(true);
    fetch(`${constants.CompanyStatusChangeUrl}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify({ companyId: companyStatusData.id } || {}),
      // body: formData
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.message) {
          if (res.message.messageCode) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setIsStatusModal(false);
            setCompanyStatusData({
              id: "",
              companyName: "",
              status: "",
            });
            // handlePageChange();
            getListUser(page - 1, searchText, sortBy, order);
            setIsApiLoading(false);
          }
        } else if (res.error) {
          if (res.error.errorCode) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setIsApiLoading(false);
          }
        }
      });
  };

  const handleDeleteCompany = () => {
    setIsApiLoading(true);
    fetch(`${constants.CompanyDeleteUrl}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify({ companyId: companyStatusData.id } || {}),
      // body: formData
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.message) {
          if (res.message.messageCode) {
            toast.success(`✅ ${res.message.messageDescription} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setIsDeleteModal(false);
            setCompanyStatusData({
              id: "",
              companyName: "",
              status: "",
            });
            // handlePageChange();
            getListUser(page - 1, searchText, sortBy, order);
            setIsApiLoading(false);
          }
        } else if (res.error) {
          if (res.error.errorCode) {
            toast.error(`❌ ${res.error.errorMessage} !`, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            });
            setIsApiLoading(false);
          }
        }
      });
  };

  const handleExport = () => {
    var url = constants.CompanyExportUrl;
    fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
    })
      .then((res) => res.blob())
      .then((response) => {
        var fileDownload = require("js-file-download");
        fileDownload(response, "UserActivity.xlsx");
      });
  };
  return (
    <Fragment>
      <div className="d-flex flex-wrap mb-4">
        <div className="mr-auto mb-2 pr-2 show-results">
          <h6 className="text-black fs-16 font-w600 mb-1">
            Showing {pageDetails?.totalElements} Company Results
          </h6>
          <span className="fs-14">Based your preferences</span>
        </div>
        <div className="d-flex flex-wrap mb-l3 mb-s1">
          <div className="input-group search-area d-xl-inline-flex">
            <input
              type="text"
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
              className="form-control input-rounded mr-auto mb-md-0 mb-3"
              placeholder="Search here..."
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <i
                  className="flaticon-381-search-2"
                  onClick={handleSearch}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
          </div>
        </div>{" "}
        &nbsp;&nbsp;
        {/* Filter  */}
        <div className="d-flex flex-wrap mb-3">
          <div>
            <div className="dropdown custom-dropdown mb-0 mt-3 mt-sm-0 mb-1">
              <button
                className="btn btn-primary"
                id="popupbox"
                onClick={openFilter}
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="18"
                  fill="currentColor"
                  class="bi bi-filter-square"
                  viewBox="0 0 16 16"
                >
                  {" "}
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />{" "}
                  <path d="M6 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />{" "}
                </svg>{" "}
                Filter
              </button>
              {/* popup */}
              <div>
                <div
                  className="modal fade show"
                  id="staticBackdrop"
                  style={{ width: "400px", height: "63%", top: 100, left: 503 }}
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabIndex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div
                        className=""
                        style={{
                          overflowY: "scroll",
                          width: "400px",
                          height: "250px",
                        }}
                      >
                        <div>
                          {/* className="modal-header" */}
                          <Col lg={12}>
                            <Card>
                              <Card.Body>
                                <h4>
                                  <b>Filter Company</b>
                                </h4>
                                <br></br>
                                <div className="row">
                                  <div className="col-xl-6">
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Status"
                                        options={statusOptions()}
                                        onChange={(value) => {
                                          handleStatus(value);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <br />
                                  {/* <div className="col-xl-6">
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Roles"
                                        options={rolesOptions()}
                                        onChange={(value) => {
                                          handleRoles(value);
                                        }}
                                      ></ReactMultiSelectCheckboxes>
                                    </div>
                                  </div> */}
                                </div>{" "}
                                <div></div>
                                <br></br>
                                <br></br>
                                <button
                                  type="button"
                                  onClick={clearFilter}
                                  className="btn btn-primary"
                                >
                                  Clear
                                </button>
                                &nbsp;&nbsp;
                                <button
                                  type="button"
                                  onClick={handleFilter}
                                  className="btn btn-primary"
                                >
                                  Apply
                                </button>
                                &nbsp;&nbsp;
                                <br></br>
                              </Card.Body>
                            </Card>
                          </Col>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;&nbsp;
        {/* Export  */}
        <div className="d-flex flex-wrap mb-3">
          <div>
            <div className="dropdown custom-dropdown mb-0 mt-3 mt-sm-0 mb-1">
              <button
                className="btn btn-primary"
                id="popupbox"
                onClick={() => {
                 handleExport();
                }}
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                <i className="fa fa-upload" aria-hidden="true" /> &nbsp; Export
              </button>
              {/* popup */}
            </div>
          </div>
        </div>
        &nbsp;&nbsp;
        {/* Add Company  */}
        {userRole === "Admin" && (
          <div className="d-flex flex-wrap mb-3">
            <div>
              <div className="dropdown custom-dropdown mb-0 mt-3 mt-sm-0 mb-1">
                <button
                  className="btn btn-primary"
                  id="popupbox"
                  onClick={() => {
                    setAddModalOpen(true);
                    setIsCompnayUpdate(false);
                    setFormData({
                      companyName: "",
                      gstNumber: "",
                      country: "",
                      state: "",
                      city: "",
                      address: "",
                      pincode: "",
                      spokeName: "",
                      spokeContactNumber: "",
                      spokeEmail: "",
                      communicationName: "",
                      communicationMobileNumber: "",
                      communicationEmail: "",
                    });
                  }}
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop"
                >
                  <i className="fa fa-plus" aria-hidden="true" /> &nbsp; Add
                  Company
                </button>
                {/* popup */}
                <Modal
                  open={addModalOpen}
                  onClose={() => setAddModalOpen(false)}
                  BackdropProps={{
                    onClick: (event) => event.stopPropagation(),
                  }}
                  aria-labelledby="company-modal-title"
                  aria-describedby="company-modal-description"
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: isMobile ? "90%" : "50%",
                      maxHeight: isMobile ? "90vh" : "80vh",
                      bgcolor: "background.paper",
                      boxShadow: 24,
                      p: isMobile ? 2 : 4,
                      borderRadius: 2,
                      overflowY: "auto",
                    }}
                  >
                    <h2 id="company-modal-title">
                      {isCompnayUpdate ? "Update Company" : "Add New Company"}
                    </h2>
                    <p id="company-modal-description">
                      Fill in the details below to{" "}
                      {isCompnayUpdate ? "update" : "add"} a company.
                    </p>
                    <Grid container spacing={2}>
                      {/* Company Name */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Company Name"
                          name="companyName"
                          value={formData.companyName}
                          onChange={handleChange}
                          required
                        />
                      </Grid>
                      {/* GST No. */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="GST No."
                          name="gstNumber"
                          value={formData.gstNumber}
                          onChange={handleChange}
                        />
                      </Grid>
                      {/* Country */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          select
                          // label="Country"
                          name="country"
                          value={formData.country}
                          onChange={(e) => {
                            handleChange(e);
                            setStates([]);
                            fetchStates(e.target.value);
                          }}
                          SelectProps={{
                            native: true,
                          }}
                          required
                        >
                          <option value="">Select Country</option>
                          {countries?.map((country) => (
                            <option
                              key={country.countryId}
                              value={country.countryName}
                            >
                              {country.countryName}
                            </option>
                          ))}
                        </TextField>
                      </Grid>
                      {/* State */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          select
                          // label="State"
                          name="state"
                          value={formData.state}
                          onChange={(e) => {
                            handleChange(e);
                            fetchCities(e.target.value);
                          }}
                          SelectProps={{
                            native: true,
                          }}
                          required
                        >
                          <option value="">Select State</option>
                          {states?.map((state) => (
                            <option key={state.stateId} value={state.stateName}>
                              {state.stateName}
                            </option>
                          ))}
                        </TextField>
                      </Grid>
                      {/* City */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          select
                          // label="City"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          SelectProps={{
                            native: true,
                          }}
                          required
                        >
                          <option value="">Select City</option>
                          {cities?.map((city, index) => (
                            <option key={index} value={city.cityName}>
                              {city.cityName}
                            </option>
                          ))}
                        </TextField>
                      </Grid>
                      {/* Address */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Address"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          required
                        />
                      </Grid>
                      {/* Pincode */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Pincode"
                          name="pincode"
                          value={formData.pincode}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value) && value.length <= 6) {
                              handleChange(e);
                            }
                          }}
                          inputProps={{ maxLength: 6 }}
                          required
                        />
                      </Grid>
                      {/* Spoke Name */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="SPOC Name"
                          name="spokeName"
                          value={formData.spokeName}
                          onChange={handleChange}
                        />
                      </Grid>
                      {/* Spoke Contact Number */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="SPOC Contact Number"
                          name="spokeContactNumber"
                          value={formData.spokeContactNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value) && value.length <= 10) {
                              handleChange(e);
                            }
                          }}
                          // onChange={handleChange}
                        />
                      </Grid>
                      {/* Spoke Email */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="SPOC Email"
                          name="spokeEmail"
                          type="email"
                          value={formData.spokeEmail}
                          onChange={handleChange}
                        />
                      </Grid>
                      {/* Communication Name */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Communication Name"
                          name="communicationName"
                          value={formData.communicationName}
                          onChange={handleChange}
                          required
                        />
                      </Grid>
                      {/* Communication Contact Number */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Communication Contact Number"
                          name="communicationMobileNumber"
                          value={formData.communicationMobileNumber}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*$/.test(value) && value.length <= 10) {
                              handleChange(e);
                            }
                          }}
                          // onChange={handleChange}
                          required
                        />
                      </Grid>
                      {/* Communication Email */}
                      <Grid item xs={12} md={6}>
                        <TextField
                          fullWidth
                          label="Communication Email"
                          name="communicationEmail"
                          type="email"
                          value={formData.communicationEmail}
                          onChange={handleChange}
                          required
                        />
                      </Grid>
                    </Grid>
                    <Box
                      sx={{
                        mt: 3,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1,
                      }}
                    >
                      <button
                        style={{
                          border: "1px solid #3c4b67",
                          padding: "5px 30px",
                          textAlign: "center",
                        }}
                        type="button"
                        className="btn btn-md"
                        onClick={() => setAddModalOpen(false)}
                      >
                        Cancel
                      </button>
                      <button
                        style={{
                          border: "none",
                          padding: "10px 35px",
                          textAlign: "center",
                        }}
                        type="button"
                        className="btn btn-primary btn-md"
                        onClick={handleSubmit}
                        disabled={isApiLoading}
                      >
                        {isCompnayUpdate ? "Update" : "Add"}
                      </button>
                    </Box>
                  </Box>
                </Modal>
                <Modal
                  open={viewModalOpen}
                  onClose={() => setViewModalOpen(false)}
                  // BackdropProps={{
                  //   onClick: (event) => event.stopPropagation(),
                  // }}
                  aria-labelledby="view-company-modal-title"
                  aria-describedby="view-company-modal-description"
                >
                  <Box
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      width: "50%",
                      maxHeight: "80vh",
                      bgcolor: "background.paper",
                      boxShadow: 24,
                      p: 4,
                      borderRadius: 2,
                      overflowY: "auto",
                    }}
                  >
                    <Typography
                      id="view-company-modal-title"
                      variant="h6"
                      gutterBottom
                    >
                      Company Details
                    </Typography>
                    {/* <Typography
                      id="view-company-modal-description"
                      variant="subtitle1"
                      gutterBottom
                    >
                      Below are the details of the selected company.
                    </Typography> */}

                    <Grid container spacing={2}>
                      {/* Company Name */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>Company Name:</strong>{" "}
                          {companyDetails.companyName}
                        </Typography>
                      </Grid>

                      {/* GST Number */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>GST No.:</strong>{" "}
                          {companyDetails.gstNumber || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Country */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>Country:</strong>{" "}
                          {companyDetails.country || "N/A"}
                        </Typography>
                      </Grid>

                      {/* State */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>State:</strong>{" "}
                          {companyDetails.state || "N/A"}
                        </Typography>
                      </Grid>

                      {/* City */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>City:</strong> {companyDetails.city || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Address */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>Address:</strong>{" "}
                          {companyDetails.address || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Pincode */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>Pincode:</strong>{" "}
                          {companyDetails.pincode || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Spoke Name */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>SPOC Name:</strong>{" "}
                          {companyDetails.spokeName || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Spoke Contact Number */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>SPOC Contact Number:</strong>{" "}
                          {companyDetails.spokeContactNumber || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Spoke Email */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>SPOC Email:</strong>{" "}
                          {companyDetails.spokeEmail || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Communication Name */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>Communication Name:</strong>{" "}
                          {companyDetails.communicationName || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Communication Contact Number */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>Communication No.:</strong>{" "}
                          {companyDetails.communicationMobileNumber || "N/A"}
                        </Typography>
                      </Grid>

                      {/* Communication Email */}
                      <Grid item xs={12} md={6}>
                        <Typography variant="body1">
                          <strong>Communication Email:</strong>{" "}
                          {companyDetails.communicationEmail || "N/A"}
                        </Typography>
                      </Grid>
                    </Grid>

                    <Box
                      sx={{
                        mt: 3,
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: 1,
                      }}
                    >
                      <button
                        style={{
                          border: "1px solid #3c4b67",
                          padding: "5px 30px",
                          textAlign: "center",
                        }}
                        type="button"
                        className="btn btn-md"
                        onClick={() => setViewModalOpen(false)}
                      >
                        Close
                      </button>
                    </Box>
                  </Box>
                </Modal>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <div id="application" className="dataTables_wrapper no-footer">
              {!userData?.length > 0 ? (
                <div>
                  <Box className="card" sx={{ width: "100%" }}>
                    <LinearProgress />
                  </Box>
                </div>
              ) : userData?.length <= 0 ? (
                <div>No records found</div>
              ) : (
                <table
                  className="table display mb-4 dataTablesCard table-responsive-xl card-table dataTable no-footer"
                  id="example5"
                >
                  <thead>
                    <tr role="row">
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Company Name</span>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("userName", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("userName", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      {/* <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Company Phone</span>
                        </div>
                      </th> */}

                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Location</span>
                        </div>
                      </th>
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Closed Position / Total Position</span>
                        </div>
                      </th>

                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Revenue generated / Earning Potential</span>
                        </div>
                      </th>

                      {loggedInUser?.roles === "Admin" && (
                        <th
                          className="sorting"
                          style={{ width: "100px", border: "none" }}
                        >
                          <div
                            class="row"
                            style={{
                              flexWrap: "unset",
                              justifyContent: "center",
                            }}
                          >
                            <span>Assign to</span>
                          </div>
                        </th>
                      )}
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Status</span>
                        </div>
                      </th>
                      {/* <th
                        className="sorting"
                        style={{ width: "60px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span></span>
                        </div>
                      </th> */}
                      {userRole === "Admin" && (
                        <th
                          className="sorting"
                          style={{ width: "60px", border: "none" }}
                        >
                          <div
                            class="row"
                            style={{
                              flexWrap: "unset",
                              justifyContent: "center",
                            }}
                          >
                            <span>Action</span>
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "15px",
                                marginLeft: "10px",
                                alignItems: "flex-start",
                              }}
                            ></div>
                          </div>
                        </th>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {userData?.map((user) => (
                      <tr
                        role="row"
                        // style={{ cursor: "pointer" }}
                        className="odd"
                      >
                        <td
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setViewModalOpen(true);
                            setCompanyDetails(user);
                          }}
                        >
                          {user.companyName}
                        </td>

                        {/* <td>
                          {user.companyMobileNumber
                            ? user.companyMobileNumber
                            : "N/A"}
                        </td> */}

                        <td>{user?.city ? user.city : "N/A"}</td>
                        <td>
                          {user?.closedPositions} / {user.totalPositions}
                        </td>
                        <td>
                          {user?.revenueGenerated} / {user.earningPotential}
                        </td>

                        {loggedInUser?.roles === "Admin" && (
                          <td>
                            <div className="d-flex align-items-center">
                              {/* <Dropdown className="dropdown float-right custom-dropdown mb-0">
                                <Dropdown.Toggle
                                  className="i-false"
                                  data-toggle="dropdown"
                                  variant=""
                                >
                                  {user.keyAccountManagerName
                                    ? user.keyAccountManagerName
                                    : "N/A"}{" "}
                                  &nbsp; &nbsp;
                                  <i className="fa fa-edit mr-1" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                                  {keyAccountManager?.map((manager, index) => (
                                    <Dropdown.Item
                                      className="dropdown-item"
                                      onClick={() =>
                                        handleAssignChange(
                                          user.companyId,
                                          manager.id
                                        )
                                      }
                                    >
                                      {manager.employeeId} - {manager.name}
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown> */}
                              <Dropdown className="dropdown float-right custom-dropdown mb-0">
                                <Dropdown.Toggle
                                  className="i-false"
                                  data-toggle="dropdown"
                                  variant=""
                                  onClick={() => {
                                    setShowAssignModal(true);
                                    setSelectedManager(user);
                                    setSelectedUser(user);
                                    // handleAssignChange(user.companyId);
                                  }}
                                >
                                  {user.keyAccountManagerName || "N/A"} &nbsp;
                                  &nbsp;
                                  <i className="fa fa-edit mr-1" />
                                </Dropdown.Toggle>
                              </Dropdown>
                            </div>
                          </td>
                        )}

                        <td>
                          <div>
                            <button
                              style={{
                                border: "none",
                                padding: "5px 10px ",
                                // backgroundColor: user.status === 'Deactivate' ? '1' : user.status === 'Active' ? '0' : '',
                                textAlign: "center",
                                cursor: `${
                                  userRole === "Admin" ? "pointer" : "default"
                                } `,
                              }}
                              type="button"
                              className="btn btn-primary btn-md"
                              onClick={() => {
                                if (userRole === "Admin") {
                                  setIsStatusModal(true);
                                }
                                setCompanyStatusData({
                                  id: user.companyId,
                                  status: user.activeFlag,
                                  companyName: user.companyName,
                                });
                              }}
                            >
                              {user?.activeFlag === 0 ? "Active" : "Inactive"}
                            </button>
                          </div>
                        </td>

                        {/* <td
                          onClick={() => {
                            setViewModalOpen(true);
                            setCompanyDetails(user);
                          }}
                        >
                          <i class="fa fa-eye" />
                        </td> */}

                        {userRole === "Admin" && (
                          <td>
                            <div className="d-flex align-items-center">
                              <Dropdown className="dropdown float-right custom-dropdown mb-0">
                                <Dropdown.Toggle
                                  className="i-false"
                                  data-toggle="dropdown"
                                  variant=""
                                >
                                  <svg
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                      stroke="#2E2E2E"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                      stroke="#2E2E2E"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                    <path
                                      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                      stroke="#2E2E2E"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                                  <Dropdown.Item
                                    className="dropdown-item"
                                    onClick={() => {
                                      handleEdit(user);
                                      setCompanyStatusData({
                                        id: user.companyId,
                                        companyName: user.companyName,
                                        status: user.activeFlag,
                                      });
                                    }}
                                  >
                                    Edit
                                  </Dropdown.Item>
                                  <Dropdown.Item
                                    className="dropdown-item"
                                    onClick={() => {
                                      setIsDeleteModal(true);
                                      setCompanyStatusData({
                                        id: user.companyId,
                                        status: user.activeFlag,
                                        companyName: user.companyName,
                                      });
                                    }}
                                  >
                                    Delete Company
                                    {/* {user?.activeFlag === 0
                                    ? "Deactivate User"
                                    : "Activate User"} */}
                                  </Dropdown.Item>
                                  <Dropdown.Item className="dropdown-item text-danger">
                                    Cancel
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info" id="example5_info">
                  Page: {page}
                </div>
                <div>
                  <Pagination
                    count={pageDetails?.totalPages}
                    page={page}
                    onChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConfirmationModal
        isOpen={isStatusModal}
        onConfirm={handleStatusChange}
        onCancel={() => setIsStatusModal(false)}
        loading={isApiLoading}
        title="Confirm Status Change"
        message={`Are you sure you want to change ${
          companyStatusData?.companyName
        }'s status to ${
          companyStatusData.status === 0 ? "inactive" : "active"
        }?`}
      />

      <ConfirmationModal
        isOpen={isDeleteModal}
        onConfirm={handleDeleteCompany}
        onCancel={() => setIsDeleteModal(false)}
        loading={isApiLoading}
        title="Confirm Status Change"
        message="Are you sure you want to delete this Company?"
      />

      <Modal
        open={showAssignModal}
        onClose={() => setShowAssignModal(false)}
        aria-labelledby="assign-modal-title"
        aria-describedby="assign-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: isMobile ? "90%" : "50%",
            maxHeight: isMobile ? "90vh" : "80vh",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: isMobile ? 2 : 4,
            borderRadius: 2,
            overflowY: "auto",
          }}
        >
          <Typography id="assign-modal-title" variant="h6" component="h2">
            {`Select Key Account Manager for ${selectedUser?.companyName}`}
          </Typography>
          <Box
            id="assign-modal-description"
            sx={{
              maxHeight: 400,
              overflowY: "auto",
              border: "1px solid #ccc",
              borderRadius: 4,
              padding: 1,
              marginBottom: 2,
            }}
          >
            {keyAccountManager?.length > 0 ? (
              <List>
                {keyAccountManager.map((manager) => (
                  // <ListItem
                  //   key={manager.id}
                  //   onClick={() => handleManagerSelect(manager)}
                  //   sx={{
                  //     cursor: "pointer",
                  //     backgroundColor:
                  //       selectedManager?.id === manager.id
                  //         ? "lightblue"
                  //         : "transparent",
                  //     "&:hover": {
                  //       backgroundColor: "lightgray",
                  //     },
                  //     borderRadius: 1,
                  //   }}
                  // >
                  //   <ListItemText
                  //     primary={`${manager.employeeId} - ${manager.name}`}
                  //   />
                  // </ListItem>

                  <ListItem
                    key={manager.id}
                    onClick={() => handleManagerSelect(manager)}
                    sx={{
                      cursor: "pointer",
                      backgroundColor:
                        (selectedManager?.id
                          ? selectedManager.id
                          : selectedManager?.keyAccountManagerId) === manager.id
                          ? "lightblue"
                          : "transparent",
                      "&:hover": {
                        backgroundColor: (
                          selectedManager?.id
                            ? selectedManager.id
                            : selectedManager?.keyAccountManagerId
                        )
                          ? "lightblue"
                          : "lightgray",
                      },
                      borderRadius: 1,
                    }}
                  >
                    <ListItemText
                      primary={`${manager.employeeId} - ${manager.name}`}
                    />
                  </ListItem>
                ))}
              </List>
            ) : (
              <Typography>No Key Account Managers available.</Typography>
            )}
          </Box>
          <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
            <button
              style={{
                border: "1px solid #3c4b67",
                padding: "5px 30px",
                textAlign: "center",
              }}
              type="button"
              className="btn btn-md"
              onClick={() => setShowAssignModal(false)}
            >
              Cancel
            </button>
            <button
              style={{
                border: "none",
                padding: "10px 35px",
                textAlign: "center",
              }}
              type="button"
              className="btn btn-primary btn-md"
              onClick={handleAssignChange}
            >
              Assign
            </button>
          </Box>
        </Box>
      </Modal>

      <ToastContainer />
    </Fragment>
  );
};

export default CompanyMaster;
